<template>
  <vs-popup class="add-additional-cost-popup"
            id="popup"
            :title="`CREATE INVOICE FOR ${product_order_code}`"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <vs-alert class="h-auto mb-8 text-lg" color="danger" v-if="!is_invoice_creatable">
        Please configure the nominal code settings before creating the first invoice.
      </vs-alert>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateInvoice)" autocomplete="off">

          <div v-if="order_note" class="vx-row mb-4">
            <div class="vx-col md:w-full w-full">
              <div class="order-note-reference p-4 rounded" style="background: rgba(var(--vs-danger), 0.1); border-left: 4px solid rgba(var(--vs-danger), 1);">
                <small class="label font-bold">Order Notes</small>
                <p class="mt-1 text-sm" style="white-space: pre-wrap;">{{ order_note }}</p>
              </div>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="date" name="date" rules="required" v-slot="{ errors }">
                <small class="label">Invoice date <span class="text-danger">*</span></small>
                <flat-pickr style="display: none" :config="{ dateFormat: 'd/m/Y'}" class="w-full" v-model="createForm.date"/>
                <flat-pickr :config="{ dateFormat: 'd/m/Y'}" class="w-full" v-model="createForm.date"/>
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                <small class="label">Note</small>
                <vs-textarea class="mb-0" v-model="createForm.note" height="70px"/>
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>


          <vs-table v-if="is_table_visible" :hoverFlat="true" :onlyClickCheckbox="true" multiple v-model="selectedItems" class="mt-8" :data="formulation_items">

            <template slot="header">
              <h5 class="mb-4">Select items</h5>
            </template>

            <template slot="thead">
              <vs-th width="10%">ITS PRODUCT CODE</vs-th>
              <vs-th width="10%">FG TYPE</vs-th>
              <vs-th width="10%">TOTAL ITEM QUANTITY (WITH RETURN STOCK) (KG)</vs-th>
              <vs-th width="10%">REMAINING QUANTITY (KG)</vs-th>
              <vs-th width="10%">SELECTED QUANTITY (KG)</vs-th>
              <vs-th width="10%">UNIT PRICE Excl VAT (KG/{{ account_currency }})</vs-th>
              <vs-th width="10%">TOTAL PRICE Excl VAT ({{ account_currency }})</vs-th>
              <vs-th width="10%">TAX CODE</vs-th>
              <vs-th width="10%">NOMINAL CODE</vs-th>
              <vs-th width="10%">SAGE DEPARTMENT</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr v-if="tr_item.remaining_to_be_quantity > 0" :data="tr_item"  :key="index_item" v-for="(tr_item, index_item) in data">

                <vs-td :data="tr_item.formulation_code">
                  {{ tr_item.formulation_code }}
                </vs-td>

                <vs-td :data="tr_item.formulation_type">
                  {{ tr_item.formulation_type }}
                </vs-td>

                <vs-td :data="tr_item.quantity">
                  {{ tr_item.quantity }}
                </vs-td>

                <vs-td :data="tr_item.remaining_to_be_quantity">
                  {{ tr_item.remaining_to_be_quantity }}
                </vs-td>

                <vs-td :data="tr_item.quantity">
                  <ValidationProvider :vid="index_item + 'selected_quantity' " :name="index_item + 'selected_quantity'" :rules="`min_qty:${tr_item.remaining_to_be_quantity}`" v-slot="{ errors }">
                    <vs-input type="text" v-model="tr_item.selected_quantity" class="w-full"
                              :name="index_item+'selected_quantity'"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </vs-td>

                <vs-td :data="tr_item.price">
                  {{ tr_item.price }}
                </vs-td>

                <vs-td :data="tr_item.quantity">
                  {{tr_item.selected_quantity ? (Number(tr_item.price) * tr_item.selected_quantity).toFixed(2) : '0.00'}}
                </vs-td>

                <vs-td :data="tr_item.price">

                  <vs-dropdown>

                    <a class="flex items-center">
                      {{ tr_item.tax_code || 'SELECT'}}
                      <i class="material-icons"> expand_more </i>
                    </a>

                    <vs-dropdown-menu style="z-index: 99999">

                      <vs-dropdown-item @click="onClickTaxCode(tax_code.code, tax_code.percent, tr_item.id)" v-for="(tax_code, index) in tax_codes" :key="index">
                        <span>{{tax_code.code}} - {{tax_code.percent}} % </span>
                      </vs-dropdown-item>

                    </vs-dropdown-menu>
                  </vs-dropdown>

                </vs-td>

                <vs-td>

                  <vs-dropdown>

                    <a class="flex items-center">
                      {{ formulation_items[index_item].sage_nominal_code ? formulation_items[index_item].sage_nominal_code : 'N/A' }}
                      <i class="material-icons"> expand_more </i>
                    </a>

                    <vs-dropdown-menu style="z-index: 99999">

                      <vs-dropdown-item @click="onClickNominalCode(nominal_code.code, nominal_code.id, tr_item.id)" v-for="(nominal_code, index) in tr_item.nominal_code_list" :key="index+'nominal_code'">
                        <span>{{nominal_code.code}} - {{nominal_code.name}} </span>
                      </vs-dropdown-item>

                    </vs-dropdown-menu>
                  </vs-dropdown>
                </vs-td>

                <vs-td>
                    <select v-model="tr_item.sage_department_id" class="default-dropdown">
                      <option v-for="option in sage_departments" :value="option.id">
                        {{ option.name }}
                      </option>
                    </select>
                </vs-td>

              </vs-tr>
            </template>

          </vs-table>

          <vs-table noDataText="Click add to add additional cost" class="mt-8" :data="createForm.add_cost">

            <template slot="header">
              <h5 class="mb-4">Additional cost</h5>
              <div class="flex flex-wrap items-center justify-end mt-8">
                <vs-button @click.stop="onClickAddAddCost()" size="small" class="ml-auto mt-2 mb-4">Add</vs-button>
              </div>
            </template>

            <template slot="thead">
              <vs-th>NAME</vs-th>
              <vs-th>AMOUNT Excl VAT ({{ account_currency }})</vs-th>
              <vs-th>VAT PERCENTAGE (%)</vs-th>
              <vs-th>NOMINAL CODE</vs-th>
              <vs-th>SAGE DEPARTMENT</vs-th>
              <vs-th></vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="index_cost" v-for="(tr_cost, index_cost) in data">

                <vs-td :data="tr_cost.name">
                  <ValidationProvider :vid="index_cost+'name'" :name="index_cost+'name'"
                                      rules="required" v-slot="{ errors }">
                    <vs-input type="text" v-model="tr_cost.name"
                              class="w-full"
                              :disabled="tr_cost.is_disabled"
                              :name="index_cost+'name'" :danger="!!errors[0]" :danger-text="errors[0]"
                              val-icon-danger="icon-x"
                              val-icon-pack="feather"/>
                  </ValidationProvider>
                </vs-td>

                <vs-td :data="tr_cost.amount">
                  <ValidationProvider :vid="index_cost+'amount'" :name="index_cost+'amount'"
                                      rules="required" v-slot="{ errors }">
                    <vs-input type="text" v-model="tr_cost.amount"
                              class="w-full"
                              :disabled="tr_cost.is_disabled"
                              :name="index_cost+'amount'" :danger="!!errors[0]" :danger-text="errors[0]"
                              val-icon-danger="icon-x"
                              val-icon-pack="feather"/>
                  </ValidationProvider>
                </vs-td>

                <vs-td :data="tr_cost.vat_percent">
                  <ValidationProvider :vid="index_cost+'vat_percent'" :name="index_cost+'vat_percent'"
                                      rules="required" v-slot="{ errors }">
                    <vs-input type="text" v-model="tr_cost.vat_percent"
                              class="w-full"
                              :disabled="tr_cost.is_disabled"
                              :name="index_cost+'vat_percent'" :danger="!!errors[0]" :danger-text="errors[0]"
                              val-icon-danger="icon-x"
                              val-icon-pack="feather"/>
                  </ValidationProvider>
                </vs-td>

                <vs-td>
                    <select v-model="tr_cost.sage_nominal_code_id" class="default-dropdown">
                      <option v-for="option in nominal_codes" :value="option.id">
                        {{ option.code }}
                      </option>
                    </select>
                </vs-td>

                <vs-td>
                    <select v-model="tr_cost.sage_department_id" class="default-dropdown">
                      <option v-for="option in sage_departments" :value="option.id" class="option">
                        {{ option.name }}
                      </option>
                    </select>
                </vs-td>

                <vs-td>
                  <div class="vx-row">
                    <vx-tooltip class="ml-2" text="Remove" position="top">
                      <vs-button @click.stop="onClickRemoveAddCost(index_cost)"
                                 size="small" color="danger" type="border" icon-pack="feather" icon="icon-trash"></vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>

              </vs-tr>
            </template>

          </vs-table>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button :disabled="!is_invoice_creatable" button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <!-- <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button> -->
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import vSelect from 'vue-select'
  const CustomerRepository = RepositoryFactory.get('customer')
  const TaxRepository = RepositoryFactory.get('tax')
  const SageSettingsRepository = RepositoryFactory.get('sage_settings');

  function initialState() {
    return {
      open: false,
      id: '',
      product_order_code: '',
      order_note: '',
      createForm: {
        add_cost: []
      },
      formulation_items: [],
      account_currency: '',
      selectedItems: [],
      add_cost: [],
      tax_codes: [],
      order_invoices: [],
      add_costs: [],
      is_table_visible: false,
      nominal_codes: [],
      sage_departments: []
    }
  }

export default {
  name: 'CreateProductOrderInvoicePopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id, product_order_code, account_currency = 'GBP', items, order_invoices, created_credit_note = [], note = '') {
      try {
        Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.id = id
        this.order_note = note || ''
        const { data } = (await CustomerRepository.getCustomerProductOrder(this.id)).data

        this.formulation_items = data.formulation_items.filter((x) => x.item_status !== 'Cancelled')
        this.order_invoices = order_invoices.filter((x) => x.status.name !== 'Cancelled')
        // Object.assign(this.formulation_items, items)
        // Object.assign(this.order_invoices, order_invoices)
        this.product_order_code = product_order_code
        this.account_currency = account_currency
        let inv_items = []
        this.order_invoices.forEach((n) => {
          inv_items = inv_items.concat(n.items)
        })
        this.formulation_items = this.formulation_items.map((x) => {
          const return_total = x.return_stock.filter((y) => !!y.is_quantity_reassigned).reduce((a, b) => a + Number(b.quantity), 0)
          x.return_stock_quantity = return_total
          x.sage_nominal_code_id = null
          x.sage_nominal_code = null
          return x
        })
        this.formulation_items.forEach((n) => {
          let related_inv = inv_items.filter((m) => n.formulation_code === m.formulation_code)
          let related_inv_total = related_inv.reduce((a, b) => a + Number(b.quantity), 0)
          let return_total = n.return_stock.reduce((a, b) => a + Number(b.quantity), 0)
          let reassigned_return_total = n.return_stock.filter((y) => !!y.is_quantity_reassigned).reduce((a, b) => a + Number(b.quantity), 0)

          n.quantity = Number(n.quantity) - Number(return_total)  + Number(reassigned_return_total)

          let related_credit_note_total = 0
          if(created_credit_note.length > 0) {
            const product_items = created_credit_note.filter((x) => x.status !== 'Invalid' ).flatMap((obj) => obj.product_items || []);
            let related_credit_notes = product_items.filter((x) => x.product_order_item_id === n.id)
            related_credit_note_total = related_credit_notes.reduce((total, { batches, total_quantity }) => {
              if(!batches || batches.length === 0) {
                batches = [{ quantity: total_quantity }]
              }
              return batches.reduce((sum, {quantity}) => sum + parseFloat(quantity), total);
            }, 0);
          }

          n.remaining_to_be_quantity = Number(n.quantity) - Number(related_inv_total) + related_credit_note_total
          n.selected_quantity = n.remaining_to_be_quantity
          n.tax_code = 'Z'
          n.tax_percent = '0.00'
          return n
        })
        if(data.add_costs.length !== 0) {
          let cost_items = []
          this.order_invoices.forEach((n) => {
            cost_items = cost_items.concat(n.add_cost)
          })
          data.add_costs.forEach((x) => {
            const find = cost_items.find((y) => y.name === x.name && Number(y.amount_ex_vat).toFixed(2) === Number(x.amount).toFixed(2))
            if(!find) {
              this.createForm.add_cost.push({ name: x.name, amount: x.amount, vat_percent: x.vat_percent, is_disabled: true, sage_nominal_code_id: x.sage_nominal_code_id })
            }
          })
        }
        await this.fetchTaxCodes()
        await this.generateNominalCode(data.country, data.formulation_items.filter((x) => x.item_status !== 'Cancelled'))
        await this.fetchNominalCodes()
        await this.fetchSageDepartments()
        this.open = true;
      } catch (error) {
        this.convertAndNotifyError(error);
      }
    },
    async generateNominalCode(country, formulation_items) {
      try {
        this.is_table_visible = false
        for (let index = 0; index < formulation_items.length; index++) {
          const element = formulation_items[index];

          const pre_defined_sage_department = element.sage_department && element.sage_department.id ? element.sage_department : null

          const { data } = (await SageSettingsRepository.getListOfSageNominalCodes(1, `filter[formulation_type]=${element.formulation_type}&filter[country]=${country}`, 150, 0)).data
          const order_item_nominal_code_list = data.filter((x) => x.is_for_surcharge === false)

          this.formulation_items[index].sage_nominal_code_id = order_item_nominal_code_list.length > 0 ? order_item_nominal_code_list[0].id : null
          this.formulation_items[index].sage_nominal_code = order_item_nominal_code_list.length > 0 ? order_item_nominal_code_list[0].code : null
          this.formulation_items[index].nominal_code_list = order_item_nominal_code_list

          //sage department mapping
          if(pre_defined_sage_department && pre_defined_sage_department.id) {
            this.formulation_items[index].sage_department_id = pre_defined_sage_department.id
          } else {
            this.formulation_items[index].sage_department_id = order_item_nominal_code_list.length === 0 ? null : (order_item_nominal_code_list[0].sage_departments.length > 0 ? order_item_nominal_code_list[0].sage_departments[0].id : null)
          }
        }
        this.is_table_visible = true
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async orderItems() {
      try {
        const { data } = (await CustomerRepository.getCustomerProductOrder(this.id)).data
        this.formulation_items = data.formulation_items

      } catch (error) {
        
      }
    },
    async fetchTaxCodes() {
      this.$vs.loading()
      try {
        const { data } =  await TaxRepository.getListOfTaxCodes(1, '', 150)
        this.tax_codes = data.data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async fetchNominalCodes() {
      try {
        const { data } = (await SageSettingsRepository.getListOfSageNominalCodes(1, ``, 150, 0)).data
        this.nominal_codes = data
      } catch (error) {
        
      }
    },
    async fetchSageDepartments() {
      try {
        const { data } = (await SageSettingsRepository.getListOfSageDepartments(1, ``, 150, 0)).data
        this.sage_departments = data
      } catch (error) {
        
      }
    },
    onClickAddAddCost() {
      this.createForm.add_cost.push({ name: null, amount: null })
    },
    onClickRemoveAddCost(index) {
      this.createForm.add_cost.splice(index, 1)
    },

    async createInvoice(){
      const vue = this;
      this.$vs.loading()
       try {
         let payload = {}
         this.createForm.add_cost = this.createForm.add_cost.map((n) => {
           n.amount = Number(n.amount).toFixed(2)
           n.vat_percent = Number(n.vat_percent).toFixed(2)
           n.sage_nominal_code_id = n.sage_nominal_code_id || null
           n.sage_department_id = n.sage_department_id || null
           delete n.is_disabled
           return n
         })
         Object.assign(payload, this.createForm)
         payload.items = this.selectedItems.map((x) => {
           return {
             customer_product_order_item_id: x.id,
             quantity: Number(x.selected_quantity),
             price: x.price,
             tax_code: x.tax_code,
             tax_percent: x.tax_percent,
             sage_nominal_code_id: x.sage_nominal_code_id || null,
             sage_department_id: x.sage_department_id || null
           }
         })
         payload.items = payload.items.filter((x) =>  x.quantity !== 0)
         await CustomerRepository.createInvoice(this.id, payload)
         this.showSuccessMessage('Invoice created successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
         this.convertAndNotifyError(e)
         this.$vs.loading.close()
       }
      this.$vs.loading.close()
    },
    async onClickCreateInvoice() {
      const allowedStatuses = ["Dispatched", "Pending Dispatch"];

      const hasInvalidStatus = this.selectedItems.some(
        ({ item_status }) => !allowedStatuses.includes(item_status)
      );
      if (hasInvalidStatus) {
        this.onClickConfirm();
        return;
      }
      await this.createInvoice();
    },
    onClickConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: "Confirm",
        text: "Some selected items are not dispatched. Are you sure you want to continue?",
        accept: () => {
          this.createInvoice();
        },
      });
    },
    onClickTaxCode(code, percent, id) {
      this.formulation_items = this.formulation_items.map((x) => {
        if(x.id === id) {
          x.tax_code = code
          x.tax_percent = percent
        }
        return x
      })
    },
    onClickNominalCode(nominal_code, nominal_id, item_id) {
      this.formulation_items = this.formulation_items.map((x) => {
        if(x.id === item_id) {
          x.sage_nominal_code = nominal_code
          x.sage_nominal_code_id = nominal_id
        }
        return x
      })
    }
  },
  mixins: [SuccessMessage, ErrorMessages],
  components: {
    flatPickr,
    'v-select': vSelect,
  },
  computed: {
    is_invoice_creatable: function() {
      return this.selectedItems.every((x) => x.sage_nominal_code_id)
    }
  }
}
</script>

<style scoped>
  .add-additional-cost-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 70% !important;
  }
  
</style>
